module.exports = __webpack_public_path__ + "img/CRM_swiperTab_bg.9200c02c.png";